import Accordion from '@ui/Accordion';
import { cn } from '@util/index';
import { ReactNode } from 'react';

interface AccordionFilterSectionProps {
  title: string;
  titleClassName?: string;
  startOpen?: boolean;
  hideBottomBorder?: boolean;
  className?: string;
  wrapperClassName?: string;
  children: ReactNode;
}

const AccordionFilterSection = ({
  title,
  titleClassName = 'text-[1.8rem] font-semibold',
  startOpen = false,
  hideBottomBorder = false,
  className,
  wrapperClassName,
  children,
}: AccordionFilterSectionProps) => {
  return (
    <div
      className={cn(
        !hideBottomBorder && 'border-b border-zinc-300',
        wrapperClassName
      )}
    >
      <Accordion
        title={title}
        titleClassName={titleClassName}
        startOpen={startOpen}
        className={className}
      >
        {children}
      </Accordion>
    </div>
  );
};

export default AccordionFilterSection;
